<template>
  <div class="MediaDashboard">
    <div
    class="MediaDashboard__content scrollbar-container"
    id="MediaDashboardScrollable">
      <transition
      name="from-right-to-left"
      mode="out-in">
        <MediaAll
        v-if="activeMediaTab('all')"/>
        <MediaAudio
        v-if="activeMediaTab('audio')"/>
        <MediaPhotos
        v-if="activeMediaTab('photo')"/>
        <MediaVideos
        v-if="activeMediaTab('video')"/>
      </transition>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'

import MediaAll from '@/components/media/dashboard/all/MediaAll'
import MediaAudio from '@/components/media/dashboard/audio/MediaAudio'
import MediaPhotos from '@/components/media/dashboard/photos/MediaPhotos'
import MediaVideos from '@/components/media/dashboard/videos/MediaVideos'

export default {
  name: 'MediaDashboard',

  components: {
    MediaAll,
    MediaAudio,
    MediaPhotos,
    MediaVideos
  },

  computed: {
    ...mapGetters('filesMedia', [
      'activeTab'
    ])
  },

  mounted () {
    this.getAllMediaFiles()
  },

  methods: {
    ...mapActions('filesMedia', [
      'getAllMediaFiles'
    ]),
    activeMediaTab (tab) {
      return this.activeTab === tab
    }
  }
}
</script>

<style lang="scss">
@import 'MediaDashboard';
</style>
